import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UserPolicy } from '@helios/state-management'

export const USERS_POLICY_URL = `helios-users`
@Injectable({
  providedIn: 'root',
})
export class HttpUserService {
  constructor(private readonly http: HttpClient) {}

  getUserPolicy(): Promise<UserPolicy> {
    return this.http.get<UserPolicy>(`${USERS_POLICY_URL}`).toPromise()
  }
}
